var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { sentenceCase } from "../../core/util/StringFormatters";
import { FlexContainer } from "../../core/components/FlexContainer";
import { TextElement } from "../../core/components/TextElement";
;
export const ClueHintList = (props) => {
    const { hints } = props, rest = __rest(props, ["hints"]);
    return (_jsx(FlexContainer, { gap: '13px', children: hints.map((hint, index) => {
            return (_jsx(TextElement, Object.assign({ text: getTextFromHintText(sentenceCase(hint)) }, rest), index));
        }) }));
};
function getTextFromHintText(hintText) {
    return `\u00A0\u2022 ${hintText}`;
}
//# sourceMappingURL=ClueHintList.js.map